// Official Red Bull M.E.O. badge — used wherever the brand lockup appears.
export default function Logo({
  className = "",
  height = 48,
}: {
  className?: string;
  height?: number;
}) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/logo.png"
      alt="Red Bull M.E.O."
      style={{ height }}
      className={`w-auto object-contain drop-shadow-[0_4px_14px_rgba(0,0,0,0.55)] ${className}`}
    />
  );
}
